import {Injectable} from '@angular/core';
import {DcpDataService} from '../dcp-data.service';
import {EddlAdobeTrackingData} from './models/eddl-adobe-tracking-data';
import {CxEvent} from '@spartacus/core';
import {UntilDestroy} from '@ngneat/until-destroy';
import {EddlStBeaconEvent} from './events/eddl-stbeacon-event';
import {EddlStlBeaconEvent} from './events/eddl-stlbeacon-event';

const ST_BEACON_READY_EVENT_NAME = 'stBeaconReady';
const STL_BEACON_READY_EVENT_NAME = 'stlBeaconReady';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class DcpEddlStBeaconReadyDataLayerService extends DcpDataService<EddlAdobeTrackingData> {
  constructor() {
    super();
  }

  fillData(event: CxEvent): EddlAdobeTrackingData {
    if (event instanceof EddlStBeaconEvent) {
      return {
        event: ST_BEACON_READY_EVENT_NAME,
      };
    }
    if (event instanceof EddlStlBeaconEvent) {
      return {
        event: STL_BEACON_READY_EVENT_NAME,
      };
    }
  }

  getData(event: CxEvent): EddlAdobeTrackingData {
    if (!(event instanceof EddlStBeaconEvent || event instanceof EddlStlBeaconEvent)) {
      return undefined;
    }
    return this.fillData(event);
  }
}
